import getTag from './internals/getTag.js';
import { symbolTag } from './internals/native.js';

function isSymbol(value) {
    return typeof value === 'symbol' || getTag(value) === symbolTag;
}

export { isSymbol as default };
